var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleSheetsWhiteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.356 9.6v1.8h9.428V9.6H7.356zM7.356 14.4v-1.8h2.357v1.8H7.356zM7.356 15.6v1.8h2.357v-1.8H7.356zM10.89 15.6v1.8h2.357v-1.8H10.89zM14.424 15.6v1.8h2.357v-1.8h-2.357zM14.424 14.4v-1.8h2.357v1.8h-2.357zM13.247 14.4H10.89v-1.8h2.357v1.8z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.604 0H4.408a.584.584 0 00-.417.176.606.606 0 00-.173.424v22.8c0 .16.062.312.173.424.11.113.26.176.417.176h15.321a.584.584 0 00.417-.176.606.606 0 00.172-.424V4.8h-4.125a.584.584 0 01-.416-.176.606.606 0 01-.173-.424V0zM6.176 9c0-.16.062-.312.172-.424a.584.584 0 01.417-.176h10.607c.156 0 .306.063.417.176.11.112.172.265.172.424v9c0 .16-.062.312-.172.424a.584.584 0 01-.417.176H6.765a.584.584 0 01-.417-.176.606.606 0 01-.172-.424V9z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.976 3.6h-3.19V.35l3.19 3.249z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/google-sheets-white-icon.0506b41d216cab70e22d6582687127a2.svg";
export { SvgGoogleSheetsWhiteIcon as ReactComponent };